export default {
  logInWithGoogle: 'Log in with Google',
  pleaseUseSkyriseCredentials: 'Please sign in with your @skyri.se or @taptapdigital.com account',
  promoText: 'Smarter data, Smarter advertising.',
  welcomeBack: 'Welcome Back'
} as Record<string, string>;
